module.exports = __webpack_public_path__ + "img/8.f324332f.jpg";